<template>
  <div class="activity-container relative" :class="{ 'from-person': !showActivityTabs }">

    <!-- 只在非个人中心跳转时显示顶部tab -->
    <div v-if="showActivityTabs" class="activity-header z-1" :class="{ 'sticky': isSticky }">
      <div class="activity-header-bg relative">
        <div class="tabs w-full h-[16%] absolute left-0 top-[5%] px-[10%] flex">
          <div v-for="(item, index) in tabs" v-trans="{
            type: 'heartbeat',
            scale: 1.1,
          }" class="relative" @click="handleTabClick(index)"
            :style="{ width: 100 / tabs.length + '%', height: '100%' }">
            <div :style="getImageStyle(index)" class="absolute">
              <div class="relative w-full h-full">
                <!-- VIP红点 -->
                <RedDot v-if="item.value === 'vip' && uiStore.getActivityBadge('vip')"
                  class="absolute top-2px right-2px z-20" />
                <!-- <div v-if="item.value === 'vip' && uiStore.getActivityBadge('vip')"
                  class="absolute top-2px right-2px w-[13px] h-[13px]">
                  <div class="relative w-full h-full text-white text-white text-[8px] flex items-center justify-center">
                    <img :src="getAssetsFile('home/messageUnreadIcon.png')" alt=""
                      class="w-[14px] h-[15px] absolute left-1px top-1px" />
                  </div>
                </div> -->
                <!-- 返利红点 -->
                <RedDot v-if="item.value === 'rebate' && uiStore.getActivityBadge('rebate')"
                  class="absolute top-3px right-9px z-20" />
                <!-- <div v-if="item.value === 'rebate' && uiStore.getActivityBadge('rebate')"
                  class="absolute top-3px right-9px w-[13px] h-[13px]">
                  <div class="relative w-full h-full text-white text-white text-[8px] flex items-center justify-center">
                    <img :src="getAssetsFile('home/messageUnreadIcon.png')" alt=""
                      class="w-[14px] h-[15px] absolute left-1px top-1px" />
                  </div>
                </div> -->
                <img v-if="index === activeTab" :src="item.img" class="w-full h-full">
              </div>

            </div>

          </div>
        </div>
        <img :src="getAssetsFile('activity/activityHeaderBg.png')" alt="" class="w-full h-auto">
      </div>
    </div>
    <div :class="{ 'h-[calc(100%-112px)] absolute overflow-y-auto top-[108px] left-0 z-2': showActivityTabs, }"
      class="activity-box w-full  ">
      <component class=" pb-[100px]" :is="tabs[activeTab].component" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { RedDot } from "@/components/RedDot";
import { ref, onMounted, onUnmounted, defineAsyncComponent, computed, onBeforeUnmount, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import useUIStore from '@/stores/modules/ui'
import { useVipStore } from '@/stores/modules/vip'
import { useActivityStore } from '@/stores/modules/activity'
import * as GameApi from '@/api/game'
// import { checkAllActivityBadges } from '@/utils/activity-badge'
import { useUserStore } from '@/stores/modules/user'
import { getAssetsFile } from '@/utils/pub-use'
import { trackPromotionClickNavEvents, trackPromotionClickNavRebate, trackPromotionClickNavVip, trackPromotionClickNavRedemptionCode, trackPromotionClickNavHistory, trackPromotionClickNavPending } from '@/utils/firebase-analytics'
const { t } = useI18n()
const uiStore = useUIStore()
const vipStore = useVipStore()
const activityStore = useActivityStore()
const userStore = useUserStore()
const route = useRoute()
const router = useRouter()

// 使用 computed 来动态生成 tabs，这样会响应语言变化
const tabs = computed(() => [
  { value: 'eventos', component: defineAsyncComponent(() => import('./components/activitys.vue')), img: getAssetsFile('activity/tab-eventos.png') },
  { value: 'rebate', component: defineAsyncComponent(() => import('./components/rebate.vue')), img: getAssetsFile('activity/tab-rebate.png') },
  { value: 'vip', component: defineAsyncComponent(() => import('./components/vip.vue')), img: getAssetsFile('activity/tab-vip.png') },
  { value: 'codigo', component: defineAsyncComponent(() => import('./components/codes.vue')), img: getAssetsFile('activity/tab-codigo.png') },
  { value: 'historico', component: defineAsyncComponent(() => import('./components/historico.vue')), img: getAssetsFile('activity/tab-historico.png') },
  // { value: 'pendente', component: defineAsyncComponent(() => import('./components/pendente.vue')) },
])

// 从 store 获取保存的 activeTab，如果没有则默认为 0
const savedTab = uiStore.getActivityActiveTab()
const activeTab = ref(savedTab >= 5 ? 0 : savedTab) // 现在只有5个标签，所以最大索引是4
const isSticky = ref(false)

// 添加 watch 来确保 activeTab 在有效范围内
watch(tabs, (newTabs) => {
  if (activeTab.value >= newTabs.length) {
    activeTab.value = 0
    uiStore.setActivityActiveTab(0)
  }
}, { immediate: true })

// 检查VIP红点状态
const checkVipBadge = async () => {
  try {
    await vipStore.loadVipData()
    const hasRewards = vipStore.vipData.drawRewardList && vipStore.vipData.drawRewardList.length > 0
    uiStore.setActivityBadge('vip', hasRewards)
  } catch (error) {
    console.error('检查VIP红点失败:', error)
  }
}

// 检查返利红点状态
const checkRebateBadge = async () => {
  try {
    const res = await GameApi.getUserAntiWater()
    const hasRewards = res.data.todayReward > 0
    uiStore.setActivityBadge('rebate', hasRewards)
  } catch (error) {
    console.error('检查返利红点失败:', error)
  }
}

// 检查Eventos红点状态
const checkEventosBadge = async () => {
  try {
    await activityStore.getBasicFinancialData()
    const hasRewards = activityStore.hasEventosBadge
    uiStore.setActivityBadge('eventos', hasRewards)
  } catch (error) {
    console.error('检查Eventos红点失败:', error)
  }
}

// 检查所有活动红点状态
const checkAllActivityBadges = async () => {
  // 只在用户已登录时才检查
  if (!userStore.isLoggedIn) {
    return
  }

  await Promise.all([
    checkVipBadge(),
    checkRebateBadge(),
    checkEventosBadge()
  ])
}

// 合并路由监听，避免重复触发
watch(() => route.query.tab, (newTab) => {
  if (newTab) {
    const idx = tabs.value.findIndex(tab => tab.value === newTab)
    if (idx !== -1 && activeTab.value !== idx) {
      activeTab.value = idx
      uiStore.setActivityActiveTab(idx)

      // 添加自动滚动
      nextTick(() => {
        scrollToActiveTab(idx)
      })
    }
  }
}, { immediate: true })

// 处理标签页点击
function handleTabClick(idx: number) {
  console.log("🚀 ~ handleTabClick ~ idx:", idx)
  switch (idx) {
    case 0:
      trackPromotionClickNavEvents()
      break
    case 1:
      trackPromotionClickNavRebate()
      break
    case 2:
      trackPromotionClickNavVip()
      break
    case 3:
      trackPromotionClickNavRedemptionCode()
      break
    case 4:
      trackPromotionClickNavHistory()
      break
    case 5:
      trackPromotionClickNavPending()
      break
    default:
      break
  }
  activeTab.value = idx
  // 保存到 store
  uiStore.setActivityActiveTab(idx)

  // 更新路由参数
  const newTab = tabs.value[idx].value
  router.replace({
    path: '/activity',
    query: { tab: newTab }
  })

  // 添加自动滚动功能
  nextTick(() => {
    scrollToActiveTab(idx)
  })
}

// 新增：滚动到激活的标签
function scrollToActiveTab(activeIndex: number) {
  const tabsContainer = document.querySelector('.tabs') as HTMLElement
  const activeTabElement = tabsContainer?.children[activeIndex] as HTMLElement

  if (tabsContainer && activeTabElement) {
    const containerWidth = tabsContainer.clientWidth
    const tabLeft = activeTabElement.offsetLeft
    const tabWidth = activeTabElement.offsetWidth

    // 计算滚动位置，让激活的标签居中显示
    const scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2)

    // 平滑滚动到目标位置
    tabsContainer.scrollTo({
      left: Math.max(0, scrollLeft),
      behavior: 'smooth'
    })
  }
}

// 你所有需要显示TabBar的一级页面路径
const tabPaths = ['/', '/activity', '/Deposito', '/wallet', '/person']

// 判断当前路由是否属于一级页面
const showTabBar = computed(() => {
  // 检查是否是从个人中心跳转到VIP页面
  const isFromPersonToVip = route.path === '/activity' &&
    route.query.tab === 'vip' &&
    sessionStorage.getItem('fromPerson') === 'true'

  // 如果是这种情况，隐藏TabBar
  if (isFromPersonToVip) {
    return false
  }

  return tabPaths.includes(route.path)
})

// 判断是否显示顶部活动tab
const showActivityTabs = computed(() => {
  const isFromPersonToVip = route.path === '/activity' &&
    route.query.tab === 'vip' &&
    sessionStorage.getItem('fromPerson') === 'true'

  // 如果是从个人中心跳转到VIP页面，隐藏顶部活动tab
  if (isFromPersonToVip) {
    return false
  }

  return true
})

// 监听路由变化，设置来源标记
watch(() => route.path, (newPath, oldPath) => {
  // 如果是从个人中心页面跳转，设置标记
  if (oldPath === '/person') {
    sessionStorage.setItem('fromPerson', 'true')
  } else if (newPath !== '/activity' || route.query.tab !== 'vip') {
    // 如果不是跳转到VIP页面，清除标记
    sessionStorage.removeItem('fromPerson')
  }
})

// 监听认证弹窗状态，当弹窗关闭且用户未登录时跳转回eventos
watch(() => uiStore.authDialog.show, (isShow) => {
  if (!isShow && !userStore.isLoggedIn) {
    // 如果当前在VIP页面且用户未登录，跳转回eventos
    if (activeTab.value === 2) { // VIP是第3个标签，索引为2
      activeTab.value = 0 // 跳转到eventos
      uiStore.setActivityActiveTab(0)
      router.replace({
        path: '/activity',
        query: { tab: 'eventos' }
      })
    }
  }
})

// 使用节流函数优化滚动性能
let ticking = false
const handleScroll = () => {
  if (!ticking) {
    requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      isSticky.value = scrollTop > 0
      ticking = false
    })
    ticking = true
  }
}
const getImageStyle = (index: number): any => {
  const getWidth = (index: number) => {
    return `width:${index}%;`
  }
  const getHeight = (index: number) => {
    return `height:${index}%;`
  }
  const getLeft = (index: number) => {
    return `left:${index}%;`
  }
  const getTop = (index: number) => {
    return `top:${index}%;`
  }
  const getScale = (num: number) => {
    return `transform:scale(${num});`
  }
  switch (index) {
    case 0: {
      return [getWidth(104), getHeight(89), getLeft(-1), getTop(11), getScale(1)].join('')
    }
    case 1: {
      return [getWidth(110), getHeight(81), getLeft(-7), getTop(5), getScale(1)].join('')
    }
    case 2: {
      return [getWidth(110), getHeight(77), getLeft(-6), getTop(4), getScale(1)].join('')
    }
    case 3: {
      return [getWidth(106), getHeight(78), getLeft(-6), getTop(6), getScale(1)].join('')
    }
    case 4: {
      return [getWidth(106), getHeight(87), getLeft(-8), getTop(12), getScale(1)].join('')
    }

  }
}
onMounted(async () => {
  // 添加滚动监听
  window.addEventListener('scroll', handleScroll, { passive: true })

  // 只在用户已登录时才检查活动红点状态
  if (userStore.isLoggedIn && !uiStore.hasAnyActivityBadge) {
    await checkAllActivityBadges()
  }
})

onUnmounted(() => {
  // 移除滚动监听
  window.removeEventListener('scroll', handleScroll)
})

// 页面卸载前保存当前状态
onBeforeUnmount(() => {
  uiStore.setActivityActiveTab(activeTab.value)
})
</script>

<style lang="scss" scoped>
.from-person::after {
  display: none !important;
}

.activity-container {
  min-height: 100vh;
  background: getPath('activity/activityBg.png') no-repeat center center;
  background-size: 100% 100%;
}

.activity-header {
  // background: #1F6749;
  // padding: 0 10px;
  height: 112px;

  transition: all 0.3s ease;


  .activity-header-bg {}
}

.activity-header.sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 移除 content-wrapper 的 padding-top，改为在吸顶时给内容添加 margin-top */
.activity-header.sticky+* {
  margin-top: 47px;
}

.vip.badge-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  background: #FF3B30;
  /* 统一为指定红色 */
  border-radius: 50%;
}

.rebate.badge-dot {
  position: absolute;
  top: 3px;
  right: 9px;
  width: 8px;
  height: 8px;
  background: #FF3B30;
  /* 统一为指定红色 */
  border-radius: 50%;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>

<route lang="json5">
    {
      name: 'activity',
      meta: {
        title: '活动',
        i18n: 'menus.activity'
      },
    }
</route>
